import axios, { AxiosResponse } from "axios";
import { Urls } from "../context/Urls";
import { RequestQueueSchema } from "../typeDef/requestQueue.model";


export async function getRequestQueue(key: string): Promise<AxiosResponse<RequestQueueSchema>> {
    return axios.get<RequestQueueSchema>(`${Urls.APP_BASE_URL}requestQueue/${key}`)
}